module.exports = __webpack_public_path__ + "img/bg-yellow-letters-down.41ee3bba.png";